export const load = () => ({
	h1: 'How To File A Noise Complaint Online Or Anonymously',
	title: 'How to File a Noise Complaint Online or Anonymously',
	description:
		'Learn how to file a noise compliant online & anonymously so local government take you seriously and resolve your noise issues.',
	showTitle: true,
});
